import { api } from '../apiMethods'
import { httpClient } from '../httpClient'
import { API_ENDPOINTS } from '@/data/constants'
import type { BusinessUpdateData } from '@/types'

export interface BusinessProfileData {
  name: string
  description: string
  website?: string
  industry: string
  designation: string
  company_size: string
  contact_info: {
    email?: string
    phone: string
    address: {
      line1: string
      line2?: string
      city: string
      state: string
      postal_code: string
      country: string
    }
  }
}

export const businessApi = {
  getProfile: () => {
    return api.get(API_ENDPOINTS.BUSINESS.PROFILE)
  },
  
  updateProfile: (data: BusinessUpdateData) => {
    return api.put(API_ENDPOINTS.BUSINESS.UPDATE, data)
  },
  
  updateProfileImage: (imageFile: File) => {
    const formData = new FormData()
    formData.append('profile_image', imageFile)

    // Use httpClient directly for FormData uploads
    // The request interceptor automatically removes Content-Type for FormData,
    // allowing the browser to set it with the correct multipart boundary
    return httpClient.post(API_ENDPOINTS.BUSINESS.PROFILE_IMAGE, formData)
  },
}